import React from 'react';
import { Button, Dropdown, Space, Tooltip } from 'antd';
import { DownOutlined } from '@ant-design/icons';

export default function RowActionsMenu({
  primaryIcon,
  primaryLabel,
  primaryTooltip,
  onPrimaryClick,
  menuItems = [],
  size = 'small',
}) {
  return (
    <div onClick={(e) => e.stopPropagation()} role="presentation">
      <Space.Compact>
        {onPrimaryClick ? (
          <Tooltip title={primaryTooltip || primaryLabel}>
            <Button
              type="default"
              size={size}
              icon={primaryIcon}
              aria-label={primaryLabel}
              onClick={(e) => {
                e.stopPropagation();
                onPrimaryClick(e);
              }}
            />
          </Tooltip>
        ) : null}
        <Dropdown
          trigger={['click']}
          menu={{
            items: menuItems,
            onClick: ({ key, domEvent }) => {
              domEvent?.stopPropagation();
              const item = menuItems.find((i) => i.key === key);
              item?.onClick?.({ key, domEvent });
            },
          }}
        >
          <Tooltip title="More actions">
            <Button
              type="default"
              size={size}
              icon={<DownOutlined />}
              aria-label="More actions"
              onClick={(e) => e.stopPropagation()}
            />
          </Tooltip>
        </Dropdown>
      </Space.Compact>
    </div>
  );
}
